class JUDEIconChooser extends HTMLElement {
  static {
    customElements.define("jude-icon-chooser", this)
  }

  connectedCallback() {
    this.addEventListener("change", this)
    this.value = this.getAttribute("value")
    if (this.value !== "") {
      const foundTmpl = [...this.querySelectorAll(`template`)].find(tmpl => {
        return tmpl.content.querySelector(`wa-option[value="${this.value}"]`)
      })
      if (foundTmpl) {
        this.querySelector(`wa-select[label="Category"]`).value = foundTmpl.dataset.category
        const portal = this.querySelector("template-portal")
        portal.replaceChildren(foundTmpl.content.cloneNode(true))
        portal.querySelector("wa-select").value = this.value
        portal.querySelector("wa-select > wa-icon").name = this.value
      }
    }
  }

  handleEvent(event) {
    // TODO: define better id connection here
    if (event.type === "change" && event.target.label === "Category") {
      const tmpl = this.querySelector(`template[data-category="${event.target.value}"]`)
      const portal = this.querySelector("template-portal")
      portal.replaceChildren(tmpl.content.cloneNode(true))
    } else if (event.type === "change" && event.target.label === "Icon") {
      event.target.querySelector(":scope > wa-icon").name = event.target.value
    }
  }
}
